import { useState } from 'react'
import Modal from 'react-bootstrap/Modal'
import BrandLogo from '../../_supplier/assets/media/close.png'
import Calendar from 'react-calendar'
import prev from '../../_supplier/assets/media/svg_supplier/left-arrow.svg'
import next from '../../_supplier/assets/media/svg_supplier/right-arrow.svg'
import { Button } from 'react-bootstrap'
const ExpiryLicence = (props: any) => {
  const [show, setShow] = useState(true)
  const handleClose = () => setShow(false)
  const handleShow = () => setShow(true)
  const [value, onChange] = useState(new Date())
  const [selectedDate, setSelectedDate] = useState<Date>(new Date());

  return (
    <>
      <Modal
        show={props.showExpiry}
        onHide={props.handleHideExpiry}
        dialogClassName='modal-dialog-centered '
        className='border-r10px'
      >
        <Modal.Header className='border-bottom-0 pb-0'>
          <img
            className='img-fluid h-35px w-35px'
            src={BrandLogo}
            alt='closebutton'
            onClick={props.handleHideExpiry}
          />
          <Modal.Title className='mx-auto fs-22 fw-700'>
            Select expiry date for Business License
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className='pb-4 pt-5 d-flex justify-content-center'>
          <Calendar
            // value={props.value}
            // onChange={(e: any) => {
            //   props.handleExpirySelect(e)
            // }}
            value={selectedDate}
            onChange={(e: any) => setSelectedDate(e)}
            minDate={new Date()}
            prev2Label={null}
            tileClassName={'demo'}
            next2Label={null}
            prevLabel={<img src={prev} height={15}></img>}
            nextLabel={<img src={next} height={15}></img>}
          />

        </Modal.Body>
        <Modal.Footer className='justify-content-center pt-0 border-top-0'>
          <Button onClick={() => props.handleExpirySelect(selectedDate)}className='btn btn-light p-5 btn-light:hover'>
            {props.skipLoading ? (
              <span className='indicator-progress' style={{ display: 'block' }}>
                Please wait...
                <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
              </span>
            ) : (<>
              <span className='indicator-label' onChange={(e: any) => {
                props.handleExpirySelect(e)
              }}>Save Date</span>
            </>
            )}
          </Button>
        </Modal.Footer>

      </Modal>
    </>
  )
}
// export {kycRejected}
export default ExpiryLicence
